import { render, staticRenderFns } from "./TeamDisband.vue?vue&type=template&id=6952e949&scoped=true"
import script from "./TeamDisband.vue?vue&type=script&lang=js"
export * from "./TeamDisband.vue?vue&type=script&lang=js"
import style0 from "./TeamDisband.vue?vue&type=style&index=0&id=6952e949&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6952e949",
  null
  
)

export default component.exports